ubian = ubian || {};

ubian.card = {};

/**
 * remove card with specified snr from account
 * @param {string} snr
 * @returns {undefined}
 */
ubian.card.remove = function (snr) {
    var dialog = $('#js-remove-card-dialog').html();
    dialog = $(dialog.replace('%snr%', snr));
    $(dialog).modal();
    $(dialog).find('.js-confirm-card-remove').click(function () {
        $.post(ubian.routes['card_remove'], {'snr': snr}, function (res) {
            $(dialog).modal('hide');
            if (res.status == 'error') {
                ubian.utils.alert(ubian.translate('JS.Error.Card.RemovalFailed'));
            } else {
                $('.js-remove-card[data-snr=' + snr + ']').parents('tr').first().remove();
                window.location.reload();
            }
        });
    });
}
/**
 * enable list of cards for editing
 * @returns {undefined}
 */
ubian.card.enableListEditing = function () {
    $('.js-card-name').each(function () {
        var name = $(this).text();
        var input = $('<input class="form-control">');
        $(input).val(name);
        $(this).html('');
        $(this).append(input);
    });
    $('.js-card-list-buttons .js-card-list-editing-hidden').hide();
    $('.js-card-list-buttons .js-card-list-editing-visible').removeClass('hidden');

    $('.js-card-list.hidden-mobile').sortable({
    });
    $('.js-card-list.visible-mobile').sortable({
        handle: '.handle'
    });
}
/**
 * save list of cards
 * @returns {undefined}
 */
ubian.card.saveList = function () {
    var list = [];
    $('.js-card-name:visible').each(function () {
        list.push({
            'snr': $(this).data('snr'),
            'name': $(this).find('input').val()
        });
    });
    $.post(ubian.routes['cards_save_list'], {'cards': list}, function (res) {
        window.location.reload();
    });
};

/**
 * set card with specified snr as active
 * @param {string} snr
 * @returns {undefined}
 */
ubian.card.setActive = function (snr) {
    $.post(ubian.routes['card_set_active'], {'snr': snr}, function () {
        window.location = ubian.routes['card_dashboard'];
    });
};

/**
 * create card name from first and lastname
 * @returns {undefined}
 */
ubian.card.initCardNameAutocomplete = function ()
{
    if ($('#js-card-add-form').length === 0) {
        return;
    }
    ubian.card.cardNameAutocompleteAllowed = true;

    $('#js-card-add-form #cardname').change(function () {
        ubian.card.cardNameAutocompleteAllowed = $(this).val() ? false : true;
    });
    $('#js-card-add-form').find('#name, #surname').on('keyup change', function () {
        if (ubian.card.cardNameAutocompleteAllowed === false) {
            return;
        }
        var newText = $('#js-card-add-form #name').val() + ' ' + $('#js-card-add-form #surname').val();
        newText = newText.replace(/^\s+/, '').replace(/\s+$/, '');
        $('#js-card-add-form #cardname').val(newText);
    });
};

$(function () {
    $('.js-remove-card').click(function () {
        ubian.card.remove($(this).data('snr'));
        return false;
    });
    $('.js-sort-rename-cards').click(function () {
        ubian.card.enableListEditing();
        return false;
    });
    $('.js-card-list-save-changes').click(function () {
        ubian.card.saveList();
        return false;
    });
    $('.js-set-active-card').click(function () {
        ubian.card.setActive($(this).data('snr'));
        return false;
    });
    $('.js-snr-help').click(function () {
        var template = $('#js-snr-info-modal').html();
        $(template).modal();
    });
    $('.js-greenkm-btn').click(function() {
        var brand = $(this).data('brand');
        var docFile = "Pravidla_vernostneho_programu_" + brand + ".pdf";
        var link = window.location.origin + "/docs/" + docFile;
        var text = ubian.translate("GreenKm.Branding.Alert.Text");

        text = text.replaceAll("#link#", link);
        ubian.utils.alert(text, ubian.translate("GreenKm.Branding.Alert.Title"), "OK");
    });
    ubian.card.initCardNameAutocomplete();
});